import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff7da518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "title" }

import { t } from '@/plugins/i18n'
import CommonDialog from '../common/CommonDialog.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: Array, required: true }
  },
  emits: ["unmounted"],
  setup(__props: any, { emit }: { emit: ({(e: 'unmounted'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: any[][]
}




console.log(props.data)

const visible = ref(true)

const typeNames = [t('商品附加项'), t('发货附加项'), t('组合商品附加项'), t('组合发货附加项')]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonDialog, {
    visible: visible.value,
    width: 650,
    hideCancelBtn: true,
    onOk: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false)),
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (visible.value=false)),
    footer: true,
    onClosed: _cache[2] || (_cache[2] = ($event: any) => (emit('unmounted'))),
    title: _unref(t)('提示')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('以下附加项已失效，请重新编辑附加项')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (adts, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex-col container",
          key: i
        }, [
          (adts.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(typeNames[i]), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adts, (adt) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: adt.additionId
                  }, _toDisplayString(adt.additionNameJp), 1))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})